import { Plan } from "../../shared/models/plan";

export class Product {
    public id: string;
    public name: string;
    public description: string;
    public programAccessTypeId: number;
    public plans: Array<Plan>;
    public courseId: number;

    constructor(obj?: any) {
        this.courseId = obj && obj.CourseId || 0;
        this.id = obj && obj.Id || '';
        this.name = obj && obj.Name || '';
        this.description = obj && obj.Description || '';
        this.programAccessTypeId = obj && obj.ProgramAccessType || 0;
        this.plans = obj && obj.Plans && obj.Plans.map(t => new Plan().deserialize(t)) || null;
    }
}